import {
  LOADING_POPULAR_RESTAURANTS,
  POPULAR_RESTAURANTS_LOADED,
  POPULAR_RESTAURANTS_LOADED_ERROR,
} from "../actions/popularRestaurants";

const initialState = {
  loading: false,
  loaded: false,
  data: [],
  error: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case LOADING_POPULAR_RESTAURANTS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POPULAR_RESTAURANTS_LOADED:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: payload,
        error: null,
      };

    case POPULAR_RESTAURANTS_LOADED_ERROR:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: [],
        error: payload,
      };
    default:
      return state;
  }
};
